import { render, staticRenderFns } from "./publishVideoOwm.vue?vue&type=template&id=7381bbb4&scoped=true&"
import script from "./publishVideoOwm.vue?vue&type=script&lang=js&"
export * from "./publishVideoOwm.vue?vue&type=script&lang=js&"
import style0 from "./publishVideoOwm.vue?vue&type=style&index=0&id=7381bbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381bbb4",
  null
  
)

export default component.exports